var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"variant":"danger","disabled":_vm.comprometimentosSelecionados.length == 0},on:{"click":function($event){$event.stopPropagation();return _vm.confirmarDescomprometerSelecionados()}}},[_c('span',[_c('i',{staticClass:"fa fa-times-circle-o mr-2"}),_vm._v(" Descomprometer\n        selecionados")])])
}
var staticRenderFns = []

export { render, staticRenderFns }